import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AlertService} from '@app/services/alert.service';
import {NameValueModel} from '@app/models/basic-structures';
import {ActiveDirectoryUserListComponent} from '@app/components/autocompletes/active-directory-user-list/active-directory-user-list.component';
import {ClearingHouse} from '@app/dto/ClearingHouse';
import {ClearingHouseService} from '@app/services/admin/clearing-house.service';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-clearing-house-add-edit',
  templateUrl: './clearing-house-add-edit.component.html',
  styleUrls: ['clearing-house-add-edit.component.scss'],
})
export class ClearingHouseAddEditComponent implements OnInit, AfterViewInit {
  _memoryModel: ClearingHouse;
  _model: ClearingHouse = new ClearingHouse();
  loading: boolean = false;
  @Input() set model(value) {
    if (value) {
      this.loading=true;
      this._model = value;
      this._memoryModel = JSON.parse(JSON.stringify(value));
    } else{
      this.loading=false;
    }
  }
  @ViewChild(ActiveDirectoryUserListComponent) responsibility: ActiveDirectoryUserListComponent;
  @ViewChild('genericForm') genericForm: any;
  @Input() isEdit: boolean = false;
  @Input() dialog: boolean = false;
  @Output() isFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isFormSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
  websiteControl = new FormControl();


  constructor(private alertService: AlertService,
              private clearingHouseService: ClearingHouseService,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  edit(flag) {
    this.isEdit = flag;
    if (!flag) {
      this.reset();
    }
  }

  reset() {
    if (this._memoryModel) {
      this._model = JSON.parse(JSON.stringify(this._memoryModel));
    } else {
      this.responsibility.resetValue();
      this.genericForm.reset();
    }
  }

  save() {
    const modelAction = {
      action: 'create',
      successMsg: 'Clearing House has been added successfully!'
    };
    if (this._model.clearingHouseId > 0) {
      modelAction.action = 'update';
      modelAction.successMsg = 'Clearing House has been updated successfully!';
    }
    this.saveClearingHouse(modelAction);
  }

  saveClearingHouse({action, successMsg}) {
    this.clearingHouseService[action](this._model).subscribe(
      data => {
        this._memoryModel = data;
        this.alertService.sendSuccess(successMsg);
        this.isFormSaved.emit(data);
      },
      err => {
        this.alertService.sendError(err.error.Message);
      }
    );
  }

  countrySelectionChanged(newCountry: NameValueModel) {
    this._model.country = newCountry.name;
  }

  citySelectionChanged(city: NameValueModel) {
    this._model.city = city.name;
  }

  ngAfterViewInit() {
    this.genericForm.statusChanges.subscribe(value => {
      const valid = value === 'VALID';
      this.isFormValid.emit(valid);
    });
  }

  modelChange(value) {
    this._model.responsibilityUser = value;
  }
}
